import _ from 'lodash';
import { DateRange } from 'src/app/shared/models/dateRange';

export class SeatInvitation {
  public seatId: string;
  public personId: string;
  public teamId: string;
  public teamName: string;
  public publicTeamName: string;
  public teamDescription: string;
  public positionId: string;
  public positionTitle: string;
  public dateRange: DateRange;
  public status: string;
  public workspaceLogoUrl: string;
  public workspaceHelpLink: string;

  constructor(seatInvitation: any = undefined) {
    if (seatInvitation) this.setProperties(seatInvitation);
  }

  invitationIsInvited(): boolean {
    return this.status === 'Invited';
  }

  invitationIsNoResponse(): boolean {
    return this.status === 'NoResponse';
  }

  invitationIsAccepted(): boolean {
    return this.status === 'Accepted';
  }

  invitationIsDeclined(): boolean {
    return this.status === 'Declined';
  }

  invitationIsNoShow(): boolean {
    return this.status === 'NoShow';
  }

  invitationResponseReceived(): boolean {
    if (this.status) {
      return (
        this.invitationIsAccepted() || this.invitationIsDeclined() || this.invitationIsNoShow()
      );
    }

    return false;
  }

  hasTeamDescription(): boolean {
    return !_.isNil(this.teamDescription);
  }

  private setProperties(seatInvitation: any) {
    this.seatId = seatInvitation.seatId;
    this.personId = seatInvitation.personId;
    this.teamId = seatInvitation.teamId;
    this.teamName = seatInvitation.teamName;
    this.publicTeamName = seatInvitation.publicTeamName;
    this.teamDescription = seatInvitation.teamDescription;
    this.positionId = seatInvitation.positionId;
    this.positionTitle = seatInvitation.positionTitle;
    this.dateRange = new DateRange(seatInvitation.startDate, seatInvitation.endDate);
    this.status = seatInvitation.status;
    this.workspaceLogoUrl = seatInvitation.workspaceLogoUrl;
  }
}
